import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { currentUser } from "../../../fb"

// reactstrap components
import {
  Container,
  Row,
  Col,
} from "reactstrap";


// core components
import Client from "./Client"
import ClientForm from "./ClientsForm"

function Clients({ partners }) {

  const [partnerCard, setPartnerCard] = useState(null)
  const [flag, setFlag] = useState(false)
  const [deleted, setDeleted] = useState([])


  //returning the title and page this helps in displaying on the actual page
  return (
    //react helmet used in order to optimize the SEO
    <>
      <Helmet>
        <title>Our Partners - Smart Event and Production Qatar's Best Event Manager </title>
        <meta name="description" content="View the Previous Partners of Smart Event and Production - Qatar's 
        best Event manager, best Event organizer, and best Event production. We offer services ranging from
        Wedding events, Birthday events, Sports events, Public Events, Conferences, Equipment rentals, and many more!"/>
        <meta name="og:title" content="View Smart Event and Production's Previous Partners" />
        <meta name="og:description" content="We have successfully served over 20 well-known companies all over Doha! Some of them
        include Red Bull, Ar Rayyan, Sheraton, the Mall of Qatar, and Many More!" />
      </Helmet>
      {/* ********* PARTNERS ********* */}
      <div className="pricing-4 section section-dark">
        {/* Container containing the title and description */}
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="6">
              <h1 className="title">OUR CLIENTS</h1>
              <h5 className="description">
                Companies and Organizations that have been a part of our successful venture.
              </h5>
            </Col>
          </Row>
          <div className="space-top" />
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              {/* <Col className="ml-auto mr-auto text-center" md="8"> */}
              {
                currentUser() &&
                <ClientForm
                  selectedCategory={partnerCard}
                  setSelectedCategory={setPartnerCard}
                  flag={flag}
                  deleted={deleted}
                  setDeleted={setDeleted}
                />
              }
            </Col>
          </Row>
          <Row>
            {/* </Col> */}
            {
              partners && partners.map((partner) =>
                <Client
                  {...partner}
                  key={partner.id}
                  partner={partner}
                  // size={size}
                  // partnerID={partner}
                  partnerCard={partnerCard}
                  setPartnerCard={setPartnerCard}
                  flag={flag}
                  setFlag={setFlag}
                  setDeleted={setDeleted}
                />
              )
            }
          </Row>
        </Container>
      </div>
      {/* ********* END OF ALL THE PARTNERS ********* */}
    </>
  );
}

export default Clients;
